import { Stack } from '@mui/material';
import { Title } from './Title';
import { RequestSharePanel } from './RequestSharePanel';
import { useIsDesktop } from 'Hooks';
import { ISuppliersResult } from 'API/Suppliers/suppliers';

interface ISummary {
  data: ISuppliersResult;
}
export const Summary = ({ data }: ISummary) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        mb: isDesktop ? undefined : '24px',
      }}
    >
      <Title data={data} />
      {isDesktop && <RequestSharePanel data={data} />}
    </Stack>
  );
};
